import Pharmacy from "./pharmacy";

export default Pharmacy;
